import React from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const NavbarHeader = ({
  isOpen,
  onToggle,
  brandConfig
}) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-700 shadow-lg">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Logo/Brand */}
        <div className="flex items-center space-x-2">
          <Logo />
          <span className="text-white font-semibold text-lg">
            {brandConfig.name}
          </span>
        </div>

        {/* Menu Button */}
        <button
          onClick={onToggle}
          className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 active:scale-95"
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : (
            <Menu className="w-6 h-6 text-white" />
          )}
        </button>
      </div>
    </div>
  );
};

export default NavbarHeader;
